import Avatar from '@components/avatar'
import { AlertTriangle, Check, Circle, Info, X } from 'react-feather'
import { toast } from 'react-toastify'
import themeConfig from '../../@core/configs/themeConfig'

const colors = {
    error: 'danger',
    success: 'success',
    warning: 'warning',
    info: 'info',
    dark: 'dark'
}

const icons = {
    error: X,
    success: Check,
    warning: AlertTriangle,
    info: Info,
    dark: Circle
}

export const ToastMessage = ({ title = '', color, message, Icono, styles = {} }) => (
    <>
        {title && <div className='toastify-header'>
            <div className='title-wrapper'>
                <Avatar size='sm' color={color} icon={<Icono size={12} />} />
                <h6 className='toast-title font-weight-bold' styles={styles}>{title}</h6>
            </div>
        </div>
        }
        <div className='toastify-body'>
            <span>{message}</span>
        </div>
    </>
)

export const CToast = ({ title = null, message = null }, mode = 'error', options = {}) => {
    return toast[mode](<ToastMessage
        title={!!message ? title : '¡Error!'}
        message={!!message ? message : 'Algo ha salido mal.'}
        color={colors[mode]}
        Icono={icons[mode]}

    />, { ...themeConfig.toastOptions, ...options })
}